import React, { useEffect, useState } from "react";

// Bootstrap
import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import Badge from "react-bootstrap/Badge";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { FormatDateWTime } from "../../utils/FormatData"; // Icons
import * as FiIcons from "react-icons/fi";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";
import { useQuery } from "@tanstack/react-query";

const Skeleton = () => {
  return (
    <div className="Scroll">
      {Array.from({ length: 5 }).map((_, i) => (
        <Card key={i} className="mb-2">
          <Card.Body>
            <div
              style={{
                width: "60%",
                height: "12px",
                background: "#e2e2e2",
                borderRadius: "4px",
                marginBottom: "10px",
              }}
            />

            <Stack direction="horizontal" gap={2}>
              <div
                style={{
                  width: "80px",
                  height: "12px",
                  background: "#e2e2e2",
                  borderRadius: "4px",
                }}
              />
              <div>·</div>
              <div
                style={{
                  width: "100px",
                  height: "12px",
                  background: "#e2e2e2",
                  borderRadius: "4px",
                }}
              />
              <div className="ms-auto">
                <div
                  style={{
                    width: "70px",
                    height: "12px",
                    background: "#e2e2e2",
                    borderRadius: "4px",
                  }}
                />
              </div>
            </Stack>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

function WidgetToSend() {
  const Auth = useAuth();
  const { uid_user, uid_partner, token } = Auth.getSessionData();
  const [dataReport, setDataReport] = useState(null);

  const { isPending, data, refetch } = useQuery({
    queryKey: ["widgetMessages", uid_partner, uid_user],
    queryFn: async () => {
      const response = await httpClient(
        "post",
        `${ApiEndpoint}reports/getLastMessages`,
        {
          idpartner: uid_partner,
          limit: 10,
          user: uid_user,
        },
        token
      );

      return await response.data;
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    setDataReport(data);
  }, [data]);

  const renderInfo = () => {
    if (isPending) return <Skeleton />;

    if (!dataReport || !dataReport.length)
      return (
        <div className="MessagesSended">
       <div className="flex justify-start items-center gap-2">
       <FiIcons.FiInbox />
       <div className="text-sm">No hay información disponible</div>
       </div>
        </div>
      );

    return (
      <div className="Scroll">
        {dataReport &&
          dataReport.map((sms) => {
            return (
              <Card key={sms.i_id}>
                <Card.Body>
                  <Card.Text>
                    <span>
                      {sms.i_messages > 1 ? (
                        <Badge bg="success">Ext</Badge>
                      ) : (
                        <></>
                      )}
                    </span>
                    {sms.j_details.Message}
                  </Card.Text>
                  <Stack direction="horizontal" gap={2}>
                    <div>
                      <span>{sms.vc_msisdn}</span>
                    </div>
                    <div>·</div>
                    <div>
                      <span>
                        {sms.b_ok ? (
                          <Badge bg="success">Entregado</Badge>
                        ) : sms.b_waiting ? (
                          <Badge bg="warning">En Proceso</Badge>
                        ) : sms.b_errorcarrier ? (
                          <Badge bg="danger">Error Operadora</Badge>
                        ) : (
                          <Badge bg="danger">No Valido</Badge>
                        )}
                      </span>
                    </div>{" "}
                    <div className="ms-auto">
                      <span>{FormatDateWTime(sms.time_id)}</span>
                    </div>
                  </Stack>
                </Card.Body>
              </Card>
            );
          })}
      </div>
    );
  };

  return (
    <>
      <div className="MessagesSended">
        <Stack direction="horizontal" gap={2}>
          <h6>Últimos mensajes enviados</h6>
          <div className="ms-auto cursor-pointer bg-gray-100 hover:bg-gray-300 w-10 h-10 flex items-center justify-center rounded-lg">
            <FiIcons.FiRefreshCw onClick={refetch} />
          </div>
        </Stack>
        {renderInfo()}
        {/* <div className="details">
            <Link to="/Reports/ReportDate">Ver detalles</Link>
          </div> */}
      </div>
    </>
  );
}

export default WidgetToSend;
